// extracted by mini-css-extract-plugin
export default {"text":"text--sJBsR","blink":"blink--zP1qg"};